import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import Toast from "./Toast";
import { hideToast } from "../../features/toast/toastSlice";

const ToastContainer = () => {
  const { visible, type, primaryMessage, secondaryMessage, rightText, icon, autoHideDuration } =
    useSelector((state) => state.toast);

  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    dispatch(hideToast());
  }, [dispatch]);

  return (
    <Toast
      visible={visible}
      type={type}
      primaryMessage={primaryMessage}
      secondaryMessage={secondaryMessage}
      rightText={rightText}
      icon={icon}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
    />
  );
};

export default ToastContainer;
